import React from 'react';
import styles from "./StepButtons.module.scss";
import NextButton from './components/nextButton';
import PrevButton from './components/prevButton';
import MobileChatButton from 'gui/components/crispChat/components/mobileChatButton';

interface IStepButtonsProps {
  submitForm?: any;
  isSubmitting?: boolean;
  setSubmitRef?: any;
  setFieldValue?: any;
  activeStep?: number;
  steps?: string[],

  loading?: boolean;
}

const StepButtons = ({setSubmitRef, ...props}: IStepButtonsProps) => (
  <div className={`${styles.stepButtons} stepButtons`}>
    <PrevButton {...props}/>
    {props.activeStep ? <div className={styles.spacing}/> : null}
    <NextButton setSubmitRef={setSubmitRef} {...props}/>
    <MobileChatButton className={styles.chatButton}/>
  </div>);

StepButtons.defaultProps = {};

export default React.memo(StepButtons);
